import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import DialogTitle from 'src/common/components/DialogTitle';
import Loader from 'src/common/components/Loader';
import { IParticipant } from 'src/interfaces/Participant';
import { IRegistration } from 'src/interfaces/Registration';
import { IFormRegistration } from 'src/interfaces/Registration';
import RegistrationForm from 'src/pages/Dashboard/Participants/forms/RegistrationForm';

interface Props extends DialogProps {
  eventName?: string;
  handleClose: () => void;
  handleSave: (registration: IFormRegistration) => void;
  isLoading?: boolean;
  selectedParticipant?: Partial<IParticipant> & { id: string };
  existingRegistration?: Partial<IRegistration>;
  priceEditable?: boolean;
  /** Edition to register for; defaults to system activeEditionId in the form */
  editionId?: string;
}

const RegistrationModal = ({
  id,
  eventName,
  isLoading,
  open,
  handleClose,
  handleSave,
  selectedParticipant,
  existingRegistration,
  priceEditable = false,
  editionId,
}: Props) => {
  const { t } = useTranslation();
  const isEditMode = !!existingRegistration?.id;

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby={`${id}-modal-title`}>
      <Loader isLoading={isLoading} />
      <DialogTitle id={`${id}-modal-title`} onClose={handleClose}>
        {isEditMode
          ? t('registrations.editRegistration')
          : selectedParticipant
            ? eventName
              ? t('registrations.registerForEdition', { eventName })
              : t('registrations.newRegistration')
            : t('registrations.newRegistration')}
      </DialogTitle>
      <RegistrationForm
        handleSave={handleSave}
        handleClose={handleClose}
        selectedParticipant={selectedParticipant}
        existingRegistration={existingRegistration}
        priceEditable={priceEditable}
        editionId={editionId}
      />
    </Dialog>
  );
};

export default RegistrationModal;

